import { render, staticRenderFns } from "./PostSroMainTableHeader.vue?vue&type=template&id=55e33e18"
import script from "./PostSroMainTableHeader.vue?vue&type=script&lang=js"
export * from "./PostSroMainTableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports